module.exports = __webpack_public_path__ + "img/chaplik.bf96a3e2.jpg";